// extracted by mini-css-extract-plugin
export var boxItems = "_72-1";
export var button = "_72-5";
export var filterGroupBox = "_72-0";
export var icon = "_72-2";
export var iconSecondary = "_72-4";
export var iconWrapper = "_72-3";